<template lang="pug">
div
  slide-show
  catalogs
  about
  videos
  brands
  map-info
</template>

<script>
import SlideShow from "./SlideShow";
import Catalogs from "./Catalogs";
import About from "./About";
import Videos from "./Videos";
import Brands from "./Brands";
import MapInfo from "./MapInfo";

export default {
  components: {
    SlideShow,
    Catalogs,
    About,
    MapInfo,
    Videos,
    Brands,
  },
};
</script>
